module.exports = __webpack_public_path__ + "img/main.9a5b9186.jpg";